import { render, staticRenderFns } from "./ImsTradingAccounts.vue?vue&type=template&id=33b1d1d8&"
import script from "./ImsTradingAccounts.vue?vue&type=script&lang=js&"
export * from "./ImsTradingAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports